export default [
  {
    name: 'Clients',
    path: '/clients',
    component: () => import('@/modules/clients/pages/Clients'),
    meta: {
      ability: [
        {
          resource: 'users',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Add Client',
    path: '/clients/add',
    component: () => import('@/modules/clients/pages/ClientDetails'),
    meta: {
      ability: [
        {
          resource: 'users',
          actions: ['create'],
        },
      ],
    },
  },
  {
    name: 'Edit Client',
    path: '/clients/edit/:id',
    component: () => import('@/modules/clients/pages/ClientDetails'),
    props: {
      editMode: true,
    },
    meta: {
      ability: [
        {
          resource: 'users/:id',
          actions: ['update'],
        },
      ],
    },
  },
  {
    name: 'profile',
    path: '/profile',
    component:
      () => import('@/modules/clients/pages/Profile'),
  },
  {
    name: 'Change Password',
    path: '/change-password',
    component: () => import('@/modules/clients/pages/ChangePassword'),
  },
]
